import { PackageEntranceTicket } from '@models/package'
import { SubscriptionDetails } from './models'

export const getEntranceTicketDownloadUrl = (subscriptionDetails: SubscriptionDetails, ticket: PackageEntranceTicket) =>
  `${subscriptionDetails.urls.entrance_tickets_download}?kind=${ticket?.kind}`
